

import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { businessAPI } from '../../services/businessAPI';

const InstagramCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    const error = params.get('error');

    const handleCallback = async () => {
      if (error) {
        console.error('Instagram OAuth error:', error);
        navigate('/dashboard/strategy?error=instagram');
        return;
      }

      if (!code) {
        navigate('/dashboard/strategy?error=missing_code');
        return;
      }

      try {
        console.log('Exchanging Instagram code for token...');
        const response = await businessAPI.handleInstagramCallback(code);

        if (response.success) {
          console.log('Instagram connected successfully');
          navigate('/dashboard/strategy?connected=instagram');
        } else {
          navigate('/dashboard/strategy?error=instagram');
        }
      } catch (err) {
        console.error('Instagram callback failed:', err);
        navigate('/dashboard/strategy?error=instagram');
      }
    };

    handleCallback();
  }, [location, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-lg font-medium text-gray-700">Connecting your Instagram account...</p>
        <p className="text-sm text-gray-500 mt-2">Please wait while we complete the login.</p>
      </div>
    </div>
  );
};

export default InstagramCallback;